export default __webpack_public_path__ + "static/media/ubi1.c0a1d861.jpg";